<template>
    <div class="pb-6">
        <div class="orc-vert-limit-header">
            <h1 class="text-2xl mb-12 mt-12"><i class="el-icon-news mr-3"></i>Nieuwsberichten</h1>
        </div>

        <div v-if="newsItems && newsItems.length > 0"  v-bind:class="{ 'pb-16': sloped }">
          <div class="w-full mb-16" v-bind:class="{ 'my-6 py-4 orc-slope bg-main': sloped }">
              <div class="orc-vert-limit-header">
                  <div>
                      <el-card shadow="hover" class="my-4" v-for="newsItem in newsItems" :key="newsItem.id">
                          <div slot="header" class="clearfix">
                              <div class="flex justify-between">
                                  <span style="line-height: 2;"> {{ newsItem.title }}</span>

                                  <div class="flex">
                                      <el-tooltip class="item" effect="dark" content="Vastgepind bericht" placement="top" v-if="newsItem.isSticky">
                                          <i class="el-icon-star-on bg-lightblue text-main p-2 rounded"></i>
                                      </el-tooltip>
                                      <el-tooltip class="item" effect="dark" content="Privé bericht" placement="top" v-if="newsItem.isPrivate">
                                          <i class="el-icon-s-flag bg-lightblue text-main p-2 ml-2 rounded"></i>
                                      </el-tooltip>
                                  </div>
                              </div>
                          </div>
                          <content-displayer :current="newsItem.description"></content-displayer>

                          <footer class="pt-2 pr-1 flex justify-end">
                              <div>
                                  <span class="text-gray-600 text-sm">
                                      <i class="el-icon-date mr-1 text-gray-600"></i>{{ moment(newsItem.createdAt).format('DD-MM-YYYY') }}
                                  </span>
                              </div>
                          </footer>
                      </el-card>
                  </div>
              </div>
          </div>
        </div>
        <div v-else>
            <div class="orc-vert-limit-header mb-12">
                Geen nieuwsberichten om weer te geven.
            </div>
        </div>
    </div>
</template>

<script>
    import ContentDisplayer from "../content/ContentDisplayer";
    export default {
        name: "News",
        props: ['branchId', 'sloped'],
        components: {
            ContentDisplayer
        },
        watch: {
            branchId: function (newVal, val) {
                this.getNewsItems()
            }
        },
        data() {
            return {
                activeName: '1',
                newsItems: this.getNewsItems()
            }
        },
        methods: {
            getNewsItems() {
                this.$http.get(`news?branch=${this.branchId}`).then((response) => {
                    this.newsItems = response.data.content
                }).catch(function (error) {
                    console.log(error)
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/home/news/News.vue